import styled from 'styled-components'

export const PlayerRowStyled = styled.div`
  display: flex;
  height: 50px;
  width: auto;
  background: #fff;
  color: #000;
  border-bottom: 3px solid #dee2e6;
  z-index: 0;
`
